<section class="connection-add-on-package-wrapper"  *ngIf="(serviceList$ | async)?.length">
  <div class="box-wrapper">
    <h2 class="title">{{ 'CONNECTION_ADD_ON_PACKAGE.TITLE' | translate }}</h2>
    <ng-container *ngFor="let item of serviceList$ | async">
      <div class="box">
        <div class="box__left">
          <div class="box__title">{{
            translate.currentLang === 'th' ? item.data.PackageHeading.th : item.data.PackageHeading.en
          }}</div>
          <div class="box__description">{{
            translate.currentLang === 'th' ? item.data.PackageDescription.th : item.data.PackageDescription.en
          }}</div>
          <a
            class="box__link flowbtn app-border-btn desktop"
            href="{{ item.data.PricingButtonLink.iv }}"
            target="{{ item.data.target.iv }}"
            rel="noopener noreferrer"
            >{{ translate.currentLang === 'th' ? item.data.PackageButton.th : item.data.PackageButton.en }}</a
          >
        </div>
        <div class="box__right" *ngIf="item.data.PricingValue.iv">
          <div class="box__pricing-text">{{
            translate.currentLang === 'th' ? item.data.PricingTextStart.th : item.data.PricingTextStart.en
          }}</div>
          <div class="box__pricing-value">{{ item.data.PricingValue.iv }}</div>
          <div class="box__pricing-text">{{
            translate.currentLang === 'th' ? item.data.PricingTextEnd.th : item.data.PricingTextEnd.en
          }}</div>
          <div class="box__pricing-sub-text">{{
            translate.currentLang === 'th' ? item.data.PricingSubText.th : item.data.PricingSubText.en
          }}</div>
        </div>
        <a
          class="box__link flowbtn app-border-btn mobile"
          href="{{ item.data.PricingButtonLink.iv }}"
          target="{{ item.data.target.iv }}"
          rel="noopener noreferrer"
          >{{ translate.currentLang === 'th' ? item.data.PackageButton.th : item.data.PackageButton.en }}</a
        >
      </div>
    </ng-container>

    <section class="contact-support">
      <div
        ><i class="fas fa-headset"></i>
        <span [innerHTML]="'CONNECTION_ADD_ON_PACKAGE.SUPPORT_TEXT' | translate"></span>
      </div>
    </section>
  </div>
</section>
